(function() {
    angular
        .module("dashboard")
        .controller("OrderUpStatusChangedModalController", [
            "$scope",
            "$uibModalInstance",
            "PermissionService",
            "status",
            OrderUpStatusChangedModalController]);

    function OrderUpStatusChangedModalController(
        $scope,
        $uibModalInstance,
        permissionService,
        status,
    ) {
        $scope.status = status;
        $scope.storeName = permissionService.userContext.StoreName;
        $scope.close = function() {
            $uibModalInstance.close();
        };
    }
})();
